/**
 * Lightweight password strength meter — purely visual feedback.
 * Score: 0=empty, 1=weak, 2=medium, 3=strong, 4=very strong.
 * No external dependency. Mobile-friendly.
 */
export const scorePassword = (pwd = "") => {
    if (!pwd) return 0;
    let score = 0;
    if (pwd.length >= 6)  score += 1;
    if (pwd.length >= 10) score += 1;
    if (/[a-z]/.test(pwd) && /[A-Z]/.test(pwd)) score += 1;
    if (/\d/.test(pwd))   score += 1;
    if (/[^A-Za-z0-9]/.test(pwd)) score += 1;
    return Math.min(4, score);
};

const LEVELS = [
    { label: "—",            color: "bg-muted",                    text: "text-muted-foreground" },
    { label: "Weak",         color: "bg-destructive",              text: "text-destructive" },
    { label: "Medium",       color: "bg-amber-500",                text: "text-amber-600 dark:text-amber-400" },
    { label: "Strong",       color: "bg-emerald-500",              text: "text-emerald-600 dark:text-emerald-400" },
    { label: "Very strong",  color: "bg-emerald-600",              text: "text-emerald-700 dark:text-emerald-300" },
];

const PasswordStrength = ({ value = "", testId = "password-strength" }) => {
    const score = scorePassword(value);
    const level = LEVELS[score];
    return (
        <div className="mt-1.5" data-testid={testId} aria-live="polite">
            <div className="flex gap-1">
                {[0, 1, 2, 3].map((i) => {
                    const filled = score > i;
                    return (
                        <span
                            key={i}
                            data-testid={`${testId}-bar-${i}`}
                            className={[
                                "h-1.5 flex-1 rounded-full transition-colors",
                                filled ? level.color : "bg-muted",
                            ].join(" ")}
                        />
                    );
                })}
            </div>
            <p className={["text-[11.5px] mt-1 ml-1 font-medium", level.text].join(" ")}>
                {value ? level.label : "Add at least 6 characters"}
            </p>
        </div>
    );
};

export default PasswordStrength;
